<template>
    <div>
        <div
            class="flex"
            :class="[
                bubbleClass,
                { 'flex-row-reverse': imagePosition === 'right' }
            ]"
        >
            <bubble
                borderClass="border-darkGrayishBlue"
                arrowStyle="point-down"
                :imagePosition="imagePosition"
            >
                <template #image>
                    <img :src="image" :class="imageClass" alt="" />
                </template>
                <slot name="greet">
                    <div :class="[greetTextClass]">
                        {{ greetText }}
                    </div>
                </slot>
            </bubble>
        </div>
        <div :class="[borderClass]">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import bubble from '@/components/bubble.vue';
import melsonImg from '@/assets/img/melson_smile.png';

export default {
    components: { bubble },
    props: {
        greetText: { type: String },
        greetTextClass: { default: 'text-blue' },
        borderClass: { default: 'border border-darkGrayishBlue rounded' },
        imageClass: { default: 'w-16' },
        bubbleClass: { default: 'ml-4 sm:ml-16' },
        image: { default: melsonImg },
        imagePosition: { type: String, default: 'left' }
    }
};
</script>
